var _defs, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    id: "svg1755",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1759"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1769"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path1767"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "custom"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,1,171,337)",
    d: "m 0,0 c 0,-8.284 -6.716,-15 -15,-15 -8.284,0 -15,6.716 -15,15 0,8.284 6.716,15 15,15 C -6.716,15 0,8.284 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1785"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,1,171,277)",
    d: "m 0,0 c 0,-8.284 -6.716,-15 -15,-15 -8.284,0 -15,6.716 -15,15 0,8.284 6.716,15 15,15 C -6.716,15 0,8.284 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1793"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,1,171,217)",
    d: "m 0,0 c 0,-8.284 -6.716,-15 -15,-15 -8.284,0 -15,6.716 -15,15 0,8.284 6.716,15 15,15 C -6.716,15 0,8.284 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1801"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,1,171,157)",
    d: "m 0,0 c 0,-8.284 -6.716,-15 -15,-15 -8.284,0 -15,6.716 -15,15 0,8.284 6.716,15 15,15 C -6.716,15 0,8.284 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1809"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,1,171,97)",
    d: "m 0,0 c 0,-8.284 -6.716,-15 -15,-15 -8.284,0 -15,6.716 -15,15 0,8.284 6.716,15 15,15 C -6.716,15 0,8.284 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1817"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#custom)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1761",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1765",
    clipPath: "url(#clipPath1769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1771",
    transform: "translate(206,457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -80 c -16.569,0 -30,-13.431 -30,-30 v -382 c 0,-16.569 13.431,-30 30,-30 h 260 c 16.569,0 30,13.431 30,30 v 382 c 0,16.569 -13.431,30 -30,30 h -80",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1773"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1775",
    transform: "translate(306,457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 20 c 0,11.046 -8.954,20 -20,20 h -60 c -11.046,0 -20,-8.954 -20,-20 V 0 l -13.359,-8.906 C -123.755,-15.837 -130,-27.505 -130,-40 v 0 H 30 v 0 c 0,12.495 -6.245,24.163 -16.641,31.094 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1777"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1779",
    transform: "translate(216,337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 140",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1781"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1783",
    transform: "translate(171,337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-8.284 -6.716,-15 -15,-15 -8.284,0 -15,6.716 -15,15 0,8.284 6.716,15 15,15 C -6.716,15 0,8.284 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1785"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1787",
    transform: "translate(216,277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 140",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1789"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1791",
    transform: "translate(171,277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-8.284 -6.716,-15 -15,-15 -8.284,0 -15,6.716 -15,15 0,8.284 6.716,15 15,15 C -6.716,15 0,8.284 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1793"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1795",
    transform: "translate(216,217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 140",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1797"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1799",
    transform: "translate(171,217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-8.284 -6.716,-15 -15,-15 -8.284,0 -15,6.716 -15,15 0,8.284 6.716,15 15,15 C -6.716,15 0,8.284 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1801"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1803",
    transform: "translate(216,157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 140",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1805"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1807",
    transform: "translate(171,157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-8.284 -6.716,-15 -15,-15 -8.284,0 -15,6.716 -15,15 0,8.284 6.716,15 15,15 C -6.716,15 0,8.284 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1809"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1811",
    transform: "translate(216,97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 140",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1813"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1815",
    transform: "translate(171,97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-8.284 -6.716,-15 -15,-15 -8.284,0 -15,6.716 -15,15 0,8.284 6.716,15 15,15 C -6.716,15 0,8.284 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1817"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.18c95b8fdc2c129d13ffd42d67d62ba4.svg";
export { ForwardRef as ReactComponent };